module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0BAMAAAA3VgbYAAAAJ1BMVEUAAAD///////////////////////////////////////////////+uPUo5AAAADXRSTlMA/0Ai5OgbH+AggMJkPMc2igAAAF1JREFUeJxjGAX0AdkFuGTYGt1xSWUIihjg0iQoikMqQ1AweHBrklFCAZoITehACqEJl1QJbil2R5xSDFNwOgOkDZfjQbbh8PKg0oZTit3RGYcMA8PsCTilRgENAACVXhxgb61RUwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/返回white.png
// module id = cbzu
// module chunks = 1